'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');

function hasPixels(dimension){
return dimension.match(/px$/);
}let

BaseResizableDirectiveController=function(){
function BaseResizableDirectiveController($scope,$element,$window){var _this=this;_classCallCheck(this,BaseResizableDirectiveController);
this._$scope=$scope;
this._$element=$element;
this._$window=$window;
this.dimensions={};
this.axisLabelMargins=this.axisLabelMargins||{left:0,right:0,top:0,bottom:0};
this._lastValidWidth=null;
this._lastValidHeight=null;

$scope.$watch('controller.dimensions',function(n,o){
if(!_.exists(n)||n===o){
return;
}

$scope.$evalAsync(function(){
_this._onDimensionsChanged(n,o);
});
},!0);
$scope.$on('resize::resize',function(){return _this._tryToUpdateDimensions()});

this._tryToUpdateDimensions();
}BaseResizableDirectiveController.prototype.

_tryToUpdateDimensions=function _tryToUpdateDimensions(){var _this2=this;
this._$scope.$evalAsync(function(){
const computedStyle=_this2._$window.getComputedStyle(_this2._$element[0]);
const computedWidth=computedStyle.width;
const computedHeight=computedStyle.height;

if(hasPixels(computedWidth)&&hasPixels(computedHeight)){
const width=parseInt(computedWidth,10);
const height=parseInt(computedHeight,10);

if(_this2._lastValidHeight===height&&_this2._lastValidWidth===width&&
width-_this2.axisLabelMargins.left-_this2.axisLabelMargins.right>0&&
height-_this2.axisLabelMargins.top-_this2.axisLabelMargins.bottom>0){
_this2.dimensions={
width:width,
height:height};

return;
}

_this2._lastValidHeight=height;
_this2._lastValidWidth=width;
}

_this2._tryToUpdateDimensions();
});
};BaseResizableDirectiveController.prototype.





_onDimensionsChanged=function _onDimensionsChanged(newDimensions,oldDimensions){

};_createClass(BaseResizableDirectiveController,[{key:'_dimensionsValid',get:function(){return _.exists(this.dimensions)&&_.exists(this.dimensions.width)&&_.exists(this.dimensions.height)}}]);return BaseResizableDirectiveController}();


module.exports=BaseResizableDirectiveController;
//# sourceMappingURL=baseResizableDirectiveController.js.map
